export default __webpack_public_path__ + "static/uniswap@2x-dff9b5cd8760a4d18fdf72ed51cec2fb.png";